import React from 'react'
import DefaultButton from '../../components/Button/Button'
import FormInput from '../../components/Input'
import MultiSelector from '../../components/MultiSelector'
import { useFormik } from 'formik'
import { staffSchema } from '../../validations/staffForm'
import { CreateStaff } from '../../interfaces/staff'
import StaffService from '../../api/staff-service'
import { showToast } from '../../utils/toast'

interface AddStaffProps {
  handleViewSelect: (view: string, queries?: Record<string, string>) => void
  isEdit?: boolean
}

const AddStaff = ({ handleViewSelect, isEdit }: AddStaffProps) => {
  const [loading, setLoading] = React.useState(false)
  const [initialValues] = React.useState<CreateStaff>({
    email: '',
    permissions: [],
  })

  React.useEffect(() => {
    if (isEdit) {
      // get user by Id
    }
  })

  const submitForm = async (data: CreateStaff) => {
    if (loading) return

    setLoading(true)
    try {
      const res = await StaffService.createStaff(data)
        console.log('success: ', res)
        showToast({
          title: 'Staff account created successfully',
          description: 'Please check staff email for further instruction',
          id: 'create-staff-success',
          status: 'success',
        })
        handleViewSelect('view')
    } catch (err: any) {
      showToast({
        title: 'An error occured creating staff',
        description: err.message,
        id: 'create-staff-error',
        status: 'error',
      })
      console.log('err: ', err)
    } finally {
      setLoading(false)
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema: staffSchema,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: () => { },
  })
  
  const handleStepper = async () => {
    if (loading || !formik.dirty) {
      return
    }

    return submitForm({
      email: formik.values.email,
      permissions: formik.values.permissions,
    })
    // }
  }

  return (
    <div className="mt-12 grid gap-y-10">
      <>
        <div className="mt-5 flex flex-col gap-3 text-gray-400 font-medium">
          <div className="gap-2.5 flex flex-col">
            <p>Email</p>
            <FormInput
              value={formik.values.email}
              onChange={formik.handleChange}
              name={'email'}
              size="md"
              placeholder="Enter staff's email"
              error={formik.errors.email}
            />
          </div>
        </div>
        <MultiSelector
          setSelectedValues={(values: string[]) => {
            formik.setFieldValue('permissions', values)
          }}
          selectedValues={formik.values.permissions}
          options={[
            {
              description: 'This permission allows users to have administative rights',
              name: 'Admin',
              value: 'admin',
            },
            {
              description: 'This permission allows users to manage residents',
              name: 'Manage Residents',
              value: 'manage_res',
            },
            {
              description: 'This permission allows users to manage staffs',
              name: 'Manage Staffs',
              value: 'manage_staffs',
            },
            {
              description: 'This permission allows users to manage security',
              name: 'Manage Security',
              value: 'manage_security',
            },
          ]}
          label={'Staff permissions'}
        />

        <div className="flex justify-end gap-5 sm:mt-20 mt-10">
          <DefaultButton
            text={'Cancel'}
            className="sm:w-52 grow sm:grow-0 hover:grow-[9] hover:sm:grow-0 text-gray-200 bg-transparent"
            buttonType="secondary"
          />
          <DefaultButton
            text={'Continue'}
            className="sm:w-52 grow sm:grow-0 hover:grow-[9] hover:sm:grow-0"
            onClick={handleStepper}
            isLoading={loading}
            loadingText="Creating..."
            disabled={!formik.isValid || loading}
          />
        </div>
      </>
    </div>
  )
}

export default AddStaff
